import { Icon, IconButton, Tooltip } from "@material-ui/core";
import { useSnackbar } from "notistack";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import DenseAppBar from "../../components/AppBar";
import Filters from "../../components/Filters";
import Meter from "../../components/Meter";
import MetricsCard from "../../components/MetricsCard";
import PaginationControlled from "../../components/Pagination";
import Placeholder from "../../components/Skeleton";
import { getDateTime } from "../../helpers/Functions";
import { Dashboard, Reducers } from "../../Interfaces/Interfaces";
import { getAgents } from "../../redux/actions/AgentActions";
import { getAgentDashboard } from "../../redux/actions/DashboardActions";
import { getPerformanceTarget } from "../../redux/actions/TransactionActions";
import { getAggregatorDashboard } from "../../redux/actions/userActions";
import PrimaryTheme from "../../Themes/Primary";
import "./agent.scss";
export default function Agents() {
  const loader = useSelector((state: Reducers) => state.internalLoader);
  const agents = useSelector((state: Reducers) => state.agents);
  const alert = useSelector((state: Reducers) => state.alert);
  const user = useSelector((state: Reducers) => state.user);
  const dashboard: Dashboard = useSelector(
    (state: Reducers) => state.dashboard
  );
  const target = useSelector((state: Reducers) => state.target);
  const userType = useSelector((state: Reducers) => state.userType);
  const agentDashboard = useSelector((state: Reducers) => state.agentDashboard);
  const agentDashboar = useSelector((state: Reducers) => console.log(state));
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [searchState, setSearchState] = React.useState("");
  const [value] = React.useState(
    target && target.targetPercentage ? target.targetPercentage : 0
  );
  const [onboardReloader, setonboardReloader] = React.useState(1);
  const [onboardLoading, setonboardLoading] = React.useState(false);
  const [period, setperiod] = React.useState(1);
  const [targetPeriod, setTargetPeriod] = React.useState(1);
  const [canOnboardAgent, setCanOnboardAgent] = React.useState(
    user.permission && user.permission.canOnboardAgent
  );
  const [TransferTargetState, setTransferTargetState]: any = React.useState(0);
  const [POSWithdrawState, setPOSWithdrawState]: any = React.useState(0);
  const [targetLoading, setTargetLoading] = React.useState(false);

  React.useEffect(() => {
    if (userType === "5") {
      setCanOnboardAgent(true);
    } else {
      if (user.permission) {
        setCanOnboardAgent(user.permission.canOnboardAgent);
      } else {
        setCanOnboardAgent(false);
      }
    }
  }, [canOnboardAgent]);
  let list = agents && agents.items;

  let filter: any = {};

  const paginationConfig = {
    page: page + 1,
    pageSize,
    id: user.id,
    whereCondition: JSON.stringify(filter),
  };

  const getIndexSeed = (index: number) => {
    paginationConfig.page = page + 1;
    return (paginationConfig.page - 1) * paginationConfig.pageSize + index + 1;
  };

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    value: any
  ) => {
    setPageSize(value.props.value);

    paginationConfig.pageSize = value.props.value;
    dispatch(getAgents(paginationConfig));
  };

  const handleRefresh = () => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    dispatch(getAgents(paginationConfig));
  };
  let onBordedFilter = { period };
  const handleChangeOnboarded = (value: any) => {
    setperiod(value);
    setonboardReloader(value);
    setonboardLoading(true);
  };
  const handleChangeTargetPeriod = (value: any) => {    
    // setTargetLoading(true);
    setTargetPeriod(value);
  };
  React.useEffect(() => {
    if (!loader) {
      setonboardLoading(false);
    }
  }, [loader]);
  React.useEffect(() => {
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });
    if (userType === "5") {
      dispatch(getAgentDashboard());
    } else {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, onboardReloader]);

  React.useEffect(() => {
    if (searchState.length >= 3) {
      filter.name = searchState;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({ type: "LOADING", payload: true });
      dispatch(getAgents(paginationConfig));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchState]);

  const handleClear = () => {
    filter = {};
    paginationConfig.whereCondition = JSON.stringify(filter);

    setSearchState("");

    dispatch({
      type: "LOADING",
      payload: true,
    });

    // dispatch(getPOSDashboard(user.id));
    dispatch(getAgents(paginationConfig));
  };

  React.useEffect(() => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    if (userType === "5" || userType === "9") {
      if (canOnboardAgent) {
        filter.aggregatorId = user.id;
        paginationConfig.whereCondition = JSON.stringify(filter);
      }
      dispatch(getAgents(paginationConfig));
      dispatch(getAggregatorDashboard());
      dispatch(getPerformanceTarget());
    }

    return () => {
      dispatch({
        type: "AGENT",
        payload: {},
      });
      dispatch({
        type: "DASHBOARD",
        payload: {},
      });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, page]);

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
      } else {
        handleRefresh();

        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert, history]);
  const handleAgentChange = (e: any) => {
    setSearchState(e);
  };
  React.useEffect(() => {
    switch (String(targetPeriod)) {
      case "1":
        setTransferTargetState(target.dailyTranferTransactionTargetCount);
        setPOSWithdrawState(
          target.dailyPosCashWithdrawalTransactionTargetCount
        );
        
        break;
      case "2":
        setTransferTargetState(target.weeklyTranferTransactionTargetCount);
        setPOSWithdrawState(
          target.weeklyPosCashWithdrawalTransactionTargetCount
        );

        break;
      case "3":
        setTransferTargetState(target.monthlyTranferTransactionTargetCount);
        setPOSWithdrawState(
          target.monthlyPosCashWithdrawalTransactionTargetCount
        );

        break;

      default:
        setTransferTargetState(target.dailyTranferTransactionTargetCount);
        setPOSWithdrawState(
          target.dailyPosCashWithdrawalTransactionTargetCount
        );

        break;
    }
  }, [dispatch, targetPeriod]);

  return (
    <React.Fragment>
      <div
        className="col-md-11 mr-auto ml-auto p-0"
        style={{
          height: "auto",
          position: "relative",
        }}
      >
        <DenseAppBar />
      </div>
      <div
        className="col-md-12 pl-0 pr-0"
        style={{
          // overflow: "auto",
          backgroundColor: PrimaryTheme.white,
          minHeight: "100vh",
          height: "auto",
        }}
      >
        <div
          className="col-md-11 ml-auto mr-auto p-0"
          style={{
            backgroundColor: PrimaryTheme.white,
            height: "100vh",
            position: "relative",
            // zIndex: 1000,
          }}
        >
          <h1
            className="mb-5 agent-title"
            style={{
              fontFamily: PrimaryTheme.fonts?.MediumFont,
              textTransform: "uppercase",
              fontSize: PrimaryTheme.fontSizes?.subtitle,
            }}
          >
            Agents
          </h1>

          {/* cards  */}
          <div className="row mb-5">
            <div
              className="col-md-4"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <MetricsCard
                id="first"
                title="Onboarded Agents"
                // value={
                //   JSON.stringify(agentDashboard.count)
                //     ? agentDashboard.count.toLocaleString()
                //     : "0"
                // }
                value={
                  JSON.stringify(agentDashboard.totalAgent)
                    ? agentDashboard.totalAgent.toLocaleString()
                    : "0"
                }
                isLoading={onboardLoading}
                buttonTitle="+ Add Agents "
                onMenuChange={(e: any) => handleChangeOnboarded(e.target.value)}
                hasMenu
                hasButton
                buttonColor={PrimaryTheme.success}
                buttonClick={() => history.push(`/agents/new`)}
                disabled={canOnboardAgent ? false : true}
              />
            </div>

            <div
              className="col-md-4"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              {/* <Meter value={0} hasMenu title="Target" hasTransfer={0} /> */}
              <Meter
                hasTransfer={TransferTargetState ? TransferTargetState : 0}
                value={POSWithdrawState ? POSWithdrawState : 0}
                isLoading={targetLoading}
                hasMenu
                title="Target"
                width={300}
                height={157}
                subTitle="Per POS/Agent"
                onMenuChange={(e: any) => handleChangeTargetPeriod(e.target.value)}
                hasSpecialFontSize={"45px"}
              />
            </div>

            <div
              className="col-md-4"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <MetricsCard
                id="third"
                value={
                  dashboard.totalAgentsWithPos
                    ? dashboard.totalAgentsWithPos
                    : "0"
                }
                buttonColor={PrimaryTheme.primary}
                hasButton
                buttonTitle="View POS Agents"
                disabled={userType === "5" ? false : true}
                title="POS Agents"
              />
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-md-12">
              <Filters
                name="Agents"
                hasSearch
                searchState={searchState}
                // isPOS
                handleSearch={(e: any) => handleAgentChange(e.target.value)}
                // onClick={(e: any) => setSearchState(e.target.value)}
                onClear={handleClear}
              />
            </div>
          </div>

          <div className="row " style={{ paddingBottom: "150px" }}>
            <div className="col-md-12 mb-3">
              {list ? (
                <React.Fragment>
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead className="thead-primary">
                        <tr className="text-center">
                          <th>#</th>
                          <th>Full Name</th>
                          <th>Date</th>
                          <th>Email</th>
                          <th>Phone Number</th>
                          <th>State/Lga</th>
                          <th>Active</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.length !== 0 &&
                          list?.map((item: any, index: number) => (
                            <tr key={index} className="text-center">
                              <th scope="row">{getIndexSeed(index)}</th>
                              <td>
                                {item.firstName} {item.lastName}
                              </td>
                              <td>{getDateTime(item.createdOn)}</td>
                              <td>{item.email}</td>
                              <td>{item.phoneNumber}</td>
                              <td>
                                {item.state && item.state} {item.state && "/"}{" "}
                                {item.lga && item.lga}
                              </td>
                              {item.active && (
                                <td>
                                  <Icon
                                    style={{
                                      color: PrimaryTheme.success,
                                    }}
                                  >
                                    check_all
                                  </Icon>
                                </td>
                              )}
                              {!item.active && (
                                <td>
                                  <Icon
                                    style={{
                                      color: PrimaryTheme.danger,
                                    }}
                                  >
                                    close
                                  </Icon>
                                </td>
                              )}
                              <td className="p-0">
                                <Tooltip title="View">
                                  <IconButton
                                    aria-label="View"
                                    onClick={() =>
                                      history.push(`/agents/details/${item.id}`)
                                    }
                                  >
                                    <Icon>visibility</Icon>
                                  </IconButton>
                                </Tooltip>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  {list.length === 0 && (
                    <React.Fragment>
                      <p className="text-center mt-3 text-dark w-100">
                        No result
                      </p>
                    </React.Fragment>
                  )}

                  <div className="col-md-12 p-0">
                    {agents.total > pageSize && (
                      <PaginationControlled
                        onPageSizeChange={handlePageSizeChange}
                        onChange={handleChange}
                        page={page}
                        total={agents.total && agents.total}
                        pageSize={pageSize}
                      />
                    )}
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
